import styled, {css} from 'styled-components';

import {mixins} from '../../styles';
import {ESize, TSize} from '../../types';

type TNumberProps = {
  size?: TSize;
  isActive?: boolean;
  disabled?: boolean;
};

const getNumberStyle = ({size = 'M'}: TNumberProps) => {
  switch (size) {
    case ESize.XL: {
      return css`
        ${mixins.round('30px')}
        ${mixins.f3}
      `;
    }

    case ESize.L: {
      return css`
        ${mixins.round('24px')}
        ${mixins.f3}
      `;
    }

    case ESize.M: {
      return css`
        ${mixins.round('20px')}
        ${mixins.f2}
      `;
    }

    case ESize.S: {
      return css`
        ${mixins.round('16px')}
        ${mixins.f1}
      `;
    }

    case ESize.XS: {
      return css`
        ${mixins.round('12px')}
        font-size: 8px;
        line-height: 0;
      `;
    }
  }
};

const Number = styled.div<TNumberProps>`
  ${getNumberStyle}
  ${mixins.flexAlign('center')}
  flex-shrink: 0;
  font-weight: 500;

  ${({disabled, isActive, theme: {palette, branding}}) =>
    disabled
      ? css`
          color: ${palette.white};
          background-color: ${palette.grey400};
        `
      : css`
          color: ${isActive ? palette.white : branding.content.primary};
          background-color: ${isActive ? palette.grey900 : palette.grey100};
        `}
`;

export {Number, TNumberProps};
